export const SMS_CONSENT_INFO =
  "SMS is not a secure or encrypted channel. Please do not include sensitive health information. For clinical matters,contact the patient directly. Do not use SMS for emergencies.";

export const CHAT_CONSENT_INFO =
  "Chat messages may contain protected health information (PHI). Please use this chat only for appropriate care-related communication. Do not use chat for emergencies.";

export const CONSENT_INFO_BG_COLOR = "#fdf6e3";
export const CONSENT_INFO_TEXT_COLOR = "#6b5b3e";
export const CONSENT_INFO_LABEL = "IMPORTANT- ";
export const CONSENT_INFO_MIN_HEIGHT = "30px";
export const CONSENT_INFO_ICON_FONT_SIZE = "15px";
